import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  inject,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CmsFacade } from '@rd/cms/facades/cms.facade';
import { ENV } from '@rd/core/tokens/rd-lib.token';
import { CampaignBanner } from '@rd/types/cms.type';
import { isNotNull } from '@rd/utils/isNotNull';
import { AnzEnvironmentType } from 'global-types';
import { filter, map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'anz-campaign-banner-home',
  templateUrl: './campaign-banner-home.component.html',
  styleUrls: ['./campaign-banner-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnzCampaignBannerHomeComponent {
  private cmsFacade = inject(CmsFacade);

  campaignBanners$ = this.cmsFacade
    .getContentByName({
      pageName: 'campaign-banners-home',
      pageType: 'campaignbannermultiple',
      locale: 'en-au',
    })
    .pipe(
      filter(isNotNull),
      map((content) => {
        if (content?.type === 'campaignbannermultiple') {
          return content.items;
        }
        return [];
      }),
    );

  hasEnabledBanners$ = this.campaignBanners$.pipe(
    untilDestroyed(this),
    map((campaignBanners) =>
      this.env === 'production'
        ? campaignBanners.some((campaignBanner) => campaignBanner.showBanner)
        : campaignBanners.some(
            (campaignBanner) => campaignBanner.previewBanner,
          ),
    ),
  );

  constructor(@Inject(ENV) private readonly env: AnzEnvironmentType) {}

  showBanner(
    campaignBanner: Omit<CampaignBanner, 'type' | 'name' | 'position'>,
  ): boolean {
    return this.env === 'production'
      ? campaignBanner.showBanner
      : campaignBanner.previewBanner;
  }
}
